var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGsfPinDrop = function SvgGsfPinDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "gsf-pin_drop_svg__a",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gsf-pin_drop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c24",
    d: "M16 22.439q3.543-2.83 5.352-5.437c1.809-2.607 1.81-3.393 1.81-4.964q0-2.01-.733-3.413c-.733-1.403-1.093-1.696-1.812-2.281s-1.495-1.009-2.329-1.273-1.596-.395-2.287-.395-1.454.132-2.288.395-1.611.688-2.33 1.273-1.323 1.345-1.812 2.281-.733 2.074-.733 3.413q0 2.357 1.81 4.964c1.81 2.607 2.991 3.551 5.353 5.437zm0 1.713a1.5 1.5 0 0 1-.507-.087 1.5 1.5 0 0 1-.462-.26q-2.623-2.053-5.246-5.095c-2.623-3.042-2.623-4.252-2.623-6.673q0-2.235.8-3.919c.8-1.684 1.223-2.065 2.068-2.827s1.795-1.335 2.848-1.718S14.972 3 15.999 3s2.067.191 3.121.574 2.003.955 2.849 1.718 1.535 1.705 2.068 2.827.8 2.429.8 3.919q0 3.631-2.623 6.673c-2.623 3.042-3.497 3.726-5.246 5.095a1.5 1.5 0 0 1-.462.26 1.5 1.5 0 0 1-.507.087zm.003-10.144q.906 0 1.537-.634a2.1 2.1 0 0 0 .631-1.54q0-.906-.634-1.537a2.1 2.1 0 0 0-1.54-.631q-.906 0-1.537.634a2.1 2.1 0 0 0-.631 1.54q0 .906.634 1.537a2.1 2.1 0 0 0 1.54.631M8 29q-.355 0-.597-.242c-.242-.242-.241-.361-.241-.6a.8.8 0 0 1 .241-.596.82.82 0 0 1 .597-.238h16q.355 0 .597.242c.242.242.241.361.241.6a.8.8 0 0 1-.241.595.82.82 0 0 1-.597.238H8z"
  }))));
};
export default SvgGsfPinDrop;